var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value > 0)?_c('span',{staticClass:"badge",class:'badge--size-' + _vm.size + ' badge--theme-' + _vm.theme},[_vm._v(_vm._s(_vm.value))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }